<template>
  <div class="flex flex-col">
    <img src="../assets/img/Check.png" alt="Sukses" srcset="" class="m-auto" />
    <h2>Sukses Terferivikasi</h2>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>